import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignComponent } from './components/sign.component';
import { SignInComponent } from './components/in/signIn.component';
import { SignUpComponent } from './components/up/signup.component';
import { CodeComponent } from './components/code/code.component';
const routes: Routes = [
  {
    path: '',
    component: SignComponent,
    children: [
      { path: 'in', component: SignInComponent },
      { path: 'up', component: SignUpComponent },
      { path: 'code', component: CodeComponent },
      { path: '**', redirectTo: 'in', pathMatch: 'full' },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoutingModule {}
